module.exports = __webpack_public_path__ + "img/full-body.3a3a747e.jpg";